import { Box, Button } from '@material-ui/core'

const AddButton = props => {

  return (
    <>
      <Box {...props}>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'flex-end',
          }}
        >
          <Button color="primary" variant="contained" onClick={props.onClick}>
            + {`${props?.type === "Language" ? "Add New" : "Create"} ${props?.type ?? ""}`}
          </Button>
        </Box>
      </Box>
    </>
  )
}
export default AddButton
